import { render, staticRenderFns } from "./AvailablePlacesSelect.vue?vue&type=template&id=1b8b9796&scoped=true"
import script from "./AvailablePlacesSelect.vue?vue&type=script&lang=js"
export * from "./AvailablePlacesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8b9796",
  null
  
)

export default component.exports